import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'sia-file-preview-email',
  host: {
    class: 'block h-full w-full',
  },
  imports: [],
  templateUrl: './file-preview-email.component.html',
  styleUrl: './file-preview-email.component.css',
})
export class FilePreviewEmailComponent {
  private readonly sanitizer = inject(DomSanitizer);

  bodyHtml = input<string>('');

  readonly safeBody = computed(() => this.sanitizer.bypassSecurityTrustHtml(this.bodyHtml()));
}
